import axios from 'utils/axios';
import type { GetObjectBaseReportResultType, GetTeamBaseReportResultType } from '@econtractor/types';
import type { ReportVatFilter } from 'modules/admin';

export const get4Objects = async (
    fromDate: number,
    toDate: number,
    isVat: ReportVatFilter,
): Promise<GetObjectBaseReportResultType | null> => {
    try {
        const response = await axios(`/reports/objects/${fromDate}/${toDate}`, { params: { isVat } });
        return response.data;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const get4Teams = async (
    fromDate: number,
    toDate: number,
): Promise<GetTeamBaseReportResultType | null> => {
    try {
        const response = await axios(`/reports/teams/${fromDate}/${toDate}`);
        return response.data;
    } catch (e) {
        console.error(e);
        return null;
    }
};
